import type { ReactNodeViewProps } from "@tiptap/react";

import React from "react";

import { NodeViewWrapper } from "@tiptap/react";

import { ProductToken } from "../chat-tokens/ProductToken";

const ProductTokenNode = ({ node }: ReactNodeViewProps<HTMLElement>) => {
  return (
    <NodeViewWrapper className="product-component">
      <ProductToken data={node.attrs.data} />
    </NodeViewWrapper>
  );
};

export default ProductTokenNode;
